import { useNavigate, useSearchParams } from "react-router-dom";

export function useClearSearchParams() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  return (keys = []) => {
    keys.forEach((key) => searchParams.delete(key));
    navigate({ search: searchParams.toString() }, { replace: true });
  };
}
